(function () {
  "use strict";

  angular.module("extra2App").controller("AppController", AppController);

  AppController.$inject = [
    "$scope",
    "$location",
    "page",
    "heromoduleservice",
    "adminservice",
    "restservice",
  ];

  function AppController(
    $scope,
    $location,
    page,
    heromoduleservice,
    adminservice,
    restservice
  ) {
    $scope.page = page;
    $scope.currentPath = false;
    $scope.mastercardPath = false;

    restservice.getMemberProfile().then(function (result) {
      var bu = result.data.businessUnit;
      localStorage.setItem("businessUnit", bu);
      adminservice.setBu(bu);
    });

    $scope.$watch(
      function () {
        return heromoduleservice.getHero();
      },
      function () {
        $scope.hasHero = heromoduleservice.getHero();
      }
    );

    $scope.$on("$routeChangeStart", function (event) {
      $scope.currentPath = !!$location.path().match("dashboard");
      $scope.mastercardPath = !!$location.path().match("mastercard");
    });
  }
})();
